import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import { IconDown } from "assets/icons/config";

const ListProductProposalMobil = ({
  index,
  item,
  brand,
  handleChange,
  expanded,
}) => {
  return (
    <Accordion
      style={{ boxShadow: "0px 4px 15px 0px #919EAB26", borderRadius: "8px" }}
      expanded={expanded == `${index}-${item.product_name}`}
      onChange={handleChange(`${index}-${item.product_name}`)}
    >
      <AccordionSummary
        expandIcon={<IconDown />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={"100%"}
        >
          <Box>
            <Typography variant="h5" fontSize={"13px"}>
              {item.product_name}
            </Typography>
            <Box display={"flex"} justifyContent={"flex-start"}>
              <Typography variant="h5" fontSize={"10px"} marginRight={'5px'}>
                Vigencia:
              </Typography>
              <Typography fontSize={"10px"}>{item.validity}</Typography>
            </Box>
          </Box>
          <Box
            width={"40%"}
            backgroundColor={brand.background}
            borderRadius={"15px"}
            margin={"24px 0px"}
            padding={"8px 0px"}
          >
            <Typography
              variant="h5"
              fontSize={"11px"}
              textAlign={"center"}
              style={{ fontWeight: "1000 !important" }}
            >
              Hoy paga
            </Typography>
            <Typography
              textAlign={"center"}
              variant="h5"
              fontSize={"17px"}
              color={brand.color}
            >
              {item.today_pay}
            </Typography>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box display={"flex"} justifyContent={"space-between"}>
          <Typography variant="h5" fontSize={"13px"}>
            Categoría
          </Typography>
          <Typography fontSize={"13px"}>{item.category}</Typography>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"}>
          <Typography variant="h5" fontSize={"13px"}>
            Tipo de pago
          </Typography>
          <Typography fontSize={"13px"}>{item.payment_type}</Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          marginBottom={"6px"}
        >
          <Typography variant="h5" fontSize={"13px"}>
            Inscripción
          </Typography>
          <Typography fontSize={"13px"}>{item.inscription}</Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          marginBottom={"6px"}
        >
          <Typography variant="h5" fontSize={"13px"}>
            Cuota mantenimiento
          </Typography>
          <Typography fontSize={"13px"}>{item.maintenance_cuot}</Typography>
        </Box>
        {item.months?.length > 0 &&
          item.months.map((item, index) => {
            return (
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                marginBottom={"6px"}
              >
                <Typography variant="h5" fontSize={"13px"}>
                  Mes {index + 1}
                </Typography>
                <Typography fontSize={"13px"}>{item}</Typography>
              </Box>
            );
          })}
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          marginBottom={"6px"}
        >
          <Typography variant="h5" fontSize={"13px"}>
            Frecuencia de pago
          </Typography>
          <Typography fontSize={"13px"}>{item.frecuency_payment}</Typography>
        </Box>
        <Box
          width={"100%"}
          backgroundColor={"#EAEAEA"}
          borderRadius={"15px"}
          margin={"24px 0px"}
          padding={"6px 0px"}
        >
          <Typography
            variant="h5"
            fontSize={"11px"}
            textAlign={"center"}
            style={{ fontWeight: "1000 !important" }}
          >
            Valor del plan
          </Typography>
          <Typography textAlign={"center"} variant="h5" fontSize={"17px"}>
            {item.value_plan}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          marginBottom={"6px"}
        >
          <Typography variant="h5" fontSize={"13px"}>
            Valor por mes
          </Typography>
          <Typography fontSize={"13px"}>{item.value_of_the_month}</Typography>
        </Box>
        <Typography variant="h5" fontSize={"13px"}>
          Descripción descuentos
        </Typography>
        <Typography
          fontSize={"17px"}
          variant="h5"
          margin={"24px 0px"}
          dangerouslySetInnerHTML={{
            __html: item.discount_descriptions,
          }}
        />
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          marginBottom={"6px"}
        >
          <Typography variant="h5" fontSize={"13px"}>
            Meses incluidos
          </Typography>
          <Typography fontSize={"13px"}>{item.month_includes}</Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          marginBottom={"6px"}
        >
          <Typography variant="h5" fontSize={"13px"}>
            Permanencia
          </Typography>
          <Typography fontSize={"13px"}>{item.permanence}</Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          marginBottom={"6px"}
        >
          <Typography variant="h5" fontSize={"13px"}>
            Tipo de prospecto
          </Typography>
          <Typography fontSize={"13px"}>{item.prospect_type}</Typography>
        </Box>
        <Typography variant="h5" fontSize={"13px"}>
          Condiciones del plan
        </Typography>
        <Typography
          margin={"20px 0px"}
          dangerouslySetInnerHTML={{
            __html: item.product_description,
          }}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default ListProductProposalMobil;
